import React from 'react';
import {
  Box,
  Grid,
  Typography,
  Link,
  Drawer,
  List,
  ListItem,
  Divider,
  useTheme,
} from '@mui/material';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

import Bo from '@shared/assets/HeaderImages/bo.svg';
import BoH from '@shared/assets/HeaderImages/boH.svg';
import College from '@shared/assets/HeaderImages/college.svg';
import CollegeH from '@shared/assets/HeaderImages/collegeH.svg';
import SignOut from '@shared/assets/HeaderImages/signOut.svg';
import { BOOKING_DETAIL } from '@shared/helpers/routes';
import { navigationButtons } from './navigationButtons';

import MenuItemLink from './MenuItemLink';

import { sxHeader } from './styles';

const MobileMenu = ({
  toggled,
  onClickHandler,
  userToken,
  user,
  loginHandler,
  pageConfiguration,
  location,
  history,
  backofficeRedirect,
  setIsHoveringBO,
  isHoveringBO,
  collegeRedirect,
  isHoveringCO,
}) => {
  const theme = useTheme();

  /** 🔹 Subcomponentes para ordenar */
  const UserSection = () => (
    <Grid>
      <Grid container justifyContent="flex-end" sx={{ p: 1 }}>
        <HighlightOffIcon
          onClick={onClickHandler}
          sx={{ color: '#FF2020', cursor: 'pointer' }}
        />
      </Grid>

      <List disablePadding>
        {userToken ? (
          <Grid
            container
            sx={{ ...sxHeader.userContainer, pr: 0, pb: 1 }}
            alignItems="flex-start"
          >
            <AccountCircleSharpIcon sx={{ mr: 1, fontSize: 30 }} />
            <Grid>
              <Typography sx={sxHeader.userName}>
                {user.name && user.lastname
                  ? `${user.name} ${user.lastname}`
                  : '-'}
              </Typography>
              <Typography sx={sxHeader.userMail}>
                {user.email ?? '-'}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <ListItem
            onClick={loginHandler}
            sx={{
              width: '100%',
              background: theme.palette.primary.main,
              cursor: 'pointer',
            }}
          >
            <AccountCircleSharpIcon sx={{ mr: 1, fontSize: 30 }} />
            <Typography sx={sxHeader.itemMenuMobile}>Iniciar sesión</Typography>
          </ListItem>
        )}
      </List>
    </Grid>
  );

  return (
    <Drawer anchor="right" open={!toggled} onClose={onClickHandler}>
      <Box role="presentation" sx={{ width: '250px' }}>
        <UserSection />
        <Divider />

        {/* 🔹 Sección principal */}
        <List>
          {pageConfiguration.site_functions.showRegisterButton && (
            <MenuItemLink
              icon={<FolderOpenIcon />}
              label="Mi Reserva"
              href={BOOKING_DETAIL}
              onClick={e => {
                if (location.pathname === '/booking/detail') {
                  e.preventDefault();
                  history.go(1);
                }
              }}
            />
          )}

          {userToken && (
            <>
              <MenuItemLink
                icon={isHoveringBO ? BoH : Bo}
                label="Back Office"
                onClick={backofficeRedirect}
                onMouseEnter={() => setIsHoveringBO(true)}
                onMouseLeave={() => setIsHoveringBO(false)}
              />

              {pageConfiguration.id === 1 && (
                <MenuItemLink
                  icon={isHoveringCO ? CollegeH : College}
                  label="College"
                  onClick={collegeRedirect}
                />
              )}

              <MenuItemLink
                icon={SignOut}
                label="Cerrar Sesión"
                onClick={loginHandler}
              />
            </>
          )}
        </List>

        <Divider />

        {/* 🔹 Navegación dinámica */}
        <List>
          {navigationButtons(pageConfiguration, history)
            .filter(btn => btn.show)
            .map((btn, i) => (
              <ListItem
                key={i}
                sx={sxHeader.menuLinksMobile}
                onClick={btn.onClick}
              >
                {btn.href ? (
                  <Link
                    href={btn.href}
                    target={btn.target}
                    sx={{ color: '#000', textDecoration: 'none' }}
                  >
                    {btn.label}
                  </Link>
                ) : (
                  <Typography sx={sxHeader.menuLinksMobile}>
                    {btn.label}
                  </Typography>
                )}
              </ListItem>
            ))}
        </List>

        <Divider />

        {/* 🔹 Logo Quince */}
        {pageConfiguration.site_functions.showFifteen && (
          <Grid sx={{ mt: 2 }}>
            <Link
              href="http://quince.viajestdh.com.ar"
              target="_blank"
              sx={{ cursor: 'pointer' }}
            >
              <Box
                component="img"
                src={pageConfiguration.site_logos.fifteenNavLogo}
                alt={pageConfiguration.site_logos.alt}
                sx={sxHeader.logoQuince}
              />
            </Link>
          </Grid>
        )}
      </Box>
    </Drawer>
  );
};

export default MobileMenu;
